class CollectionList extends HTMLElement {
  constructor() {
    super();

    this.indexMobile = 0
    this.buttons = this.querySelectorAll('.js-fetch-collection')
    this.container = this.querySelector('#collection-items-container')
    this.isMobile = window.innerWidth < 768

    Array.from(this.buttons).forEach((button, index) => {
      button.addEventListener('click', (e) => {
        
        Array.from(this.buttons).forEach((btn) => {
          btn.classList.remove('active');
        });
    
        // Add 'active' class to the clicked button
        e.target.classList.add('active');
    
        e.preventDefault();

        this.enableLoading()

        const handle = button.dataset.handle;

        if (this.isMobile) {
          this.container.innerHTML = ''
          this.indexMobile = index
        }

        this.getCollectionItems(handle)
      })
    })
  }

  getCollectionItems(handle) {
    fetch(`${routes.collections_url}/${handle}?view=ajax`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(res => res.text())
      .then(data => {
        const newHtml = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section');

        if (!this.isMobile) {
          this.container.innerHTML = newHtml.innerHTML;
          this.initSlider(this.container.querySelector('.swiper-container'))
        } else {
          this.querySelector(`#collection-items-container-mobile-${this.indexMobile}`).innerHTML = newHtml.innerHTML
        }

        this.disableLoading();
      })
  }

  initSlider(container) {
    const swiper = new Swiper(container, {
      spaceBetween: 36,
      slidesPerView: 2,
      // If slidesPerGroup is removed, there is a strange bug which slides the slider to the next slides if you click a button in product-form
      slidesPerGroup: 2,
      speed: 400,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 23,
          slidesPerGroup: 4,
        },
      },
    });
  }

  enableLoading() {
    this.container.classList.add('loading')
  }

  disableLoading() {
    this.container.classList.remove('loading')
  }
}

customElements.define('collection-list', CollectionList);
